export default "__VITE_ASSET__B_AiJpNL__"